export class OfficerChangedPin {
  constructor(public Pin: string | null) {}
}
